import './App.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import 'react-toastify/dist/ReactToastify.css'
import Footer from './components/Footer/Footer'
import Form from './components/Form/Form'
import Header from './components/Header/Header'
import MySlider from './components/MySlider/MySlider'
import Stage from './components/Stage/Stage'
import Welcome from './components/Welcome/Welcome'
import content from './content.json'
import Servers from './components/Servers/Servers'
import { ToastContainer } from 'react-toastify'
import LogoSlide from './components/LogoSlide/LogoSlide'

function App() {
  return (
    <div className='app'>
      <main id='main' className='flex jcc'>
        <div className='wrap1 flex'>
          <Header />
          <Welcome />
        </div>
      </main>
      <section id='about' className='flex jcc'>
        <div className='wrap1'>
          <h2 className='nop'>
            Что мы <span className='vector v2'>у</span>меем?
          </h2>
        </div>
        <MySlider content={content.team.cards} />
      </section>
      <section id='service' className='flex jcc'>
        <div className='wrap1'>
          <h2 className='nop'>Услуги</h2>
        </div>
        <MySlider content={content.service.cards} />
      </section>
      <section id='works' className='flex jcc bg'>
        <div className='wrap1'>
          <h2 className='nop'>
            Раб<span className='vector v2'>о</span>ты
          </h2>
        </div>
        <MySlider content={content.works.cards} />
      </section>
      <section className='flex jcc stages'>
        <div className='wrap1'>
          <h2>Этапы проекта</h2>
          <div className='flex jcc' style={{ gap: 20 }}>
            {content.stages.cards.map((item, index) => (
              <Stage key={item.p} p={item.p} h3={index + 1} curve={item.curve} />
            ))}
          </div>
        </div>
      </section>
      <section id='contact-us' className='flex jcc contact welcome withBack'>
        <div className='wrap1'>
          <div className='flex sb'>
            <div>
              <h1>
                РАССКА<span className='vector v3'>Ж</span>ИТЕ О СВОЕМ БИЗНЕСЕ
              </h1>
              <p style={{ fontSize: '20px', color: '#757575' }}>
                Оставьте вашу заявку или свяжитесь с нами по&nbsp;номеру{' '}
                <a href='tel:+79313486968' style={{ color: 'var(--Primary)', textWrap: 'nowrap' }}>
                  +7&nbsp;931&nbsp;348-69-68
                </a>
                <br />
                Проведем бесплатный анализ вашего бизнеса и выявим все возможности для повышения его эффективности.
              </p>
            </div>
            <Form />
          </div>
        </div>
      </section>
      <Footer />
      <div className='copyright flex jcc'>
        <div className='wrap1 flex sb'>
          <p>Copyright © 2023 RMe</p>
          <p>Все права защищены</p>
        </div>
      </div>
      <ToastContainer
        position='bottom-right'
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme='light'
      />
    </div>
  )
}

export default App
